var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.isLoading}},[(_vm.table != null)?_c('spreadify-plugin',{attrs:{"mapping":_vm.table.mapping,"config":_vm.table.config,"data":_vm.table.data,"isEditable":true},on:{"savedFormData":_vm.savedData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }